import { threatAnalyticsAxios } from "@phc/common/gen/threatAnalyticsApiMutator"
import type { NwssSignalSampleList } from "./nwssSampleTypes"

export interface NwssSamplesQueryParams {
  include_non_detects: boolean
  context_days: number
}

export const fetchNwssSignalSamples = async (
  eventId: string,
  params: NwssSamplesQueryParams,
  signal?: AbortSignal
): Promise<NwssSignalSampleList> => {
  const { data } = await threatAnalyticsAxios.get<NwssSignalSampleList>(
    `/nwss/biothreat-signals/${eventId}/samples`,
    { params, signal }
  )
  return data
}
